import { useEffect, useMemo } from 'react';

import { usePostRecentService, useServiceAppState, useServiceMetaQuery } from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

/**
 * 서비스 변경을 감지하여 최근 사용 서비스를 업데이트합니다.
 */
const useRecentServiceEffect = () => {
  const {
    state: { status },
  } = useServiceAppState();
  const { data: serviceMeta } = useServiceMetaQuery();
  const serviceKeyword = useMemo(() => serviceMeta?.keyword, [serviceMeta?.keyword]);

  const { mutate } = usePostRecentService();
  useEffect(() => {
    if (status !== STATUS_CODE.OK) return;
    if (!serviceKeyword) return;
    mutate({ serviceKeyword });
  }, [mutate, status, serviceKeyword]);
};

export default useRecentServiceEffect;
